import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

export interface DynamicElement {
    name: string;
    content: string;
    slug: string;
    created: Date;
    modified: Date;
    basicEdit: boolean;
    companyId: number | null;
}

@Injectable({
    providedIn: 'root',
})
export class DynamicElementsService implements OnDestroy {
    public dynamicElements: DynamicElement[] = [];

    public loaded$ = new Subject<boolean>();

    private subscriptions: Subscription[] = [];
    constructor(
        private http: HttpClient,
        private sanitizer: DomSanitizer
    ) {
        this.getDynamicElements();
    }

    ngOnDestroy() {
        this.subscriptions.forEach((el) => el.unsubscribe());
    }

    async getDynamicElements() {
        if (this.dynamicElements.length) {
            return;
        }
        const dynamicElements = await this.http
            .get<DynamicElement[]>(`${window.location.origin}/api/shared/elements`)
            .toPromise();
        this.dynamicElements = dynamicElements;
        this.loaded$.next(true);
        this.loaded$.complete();
    }

    getElementContentBySlug(slug: string, onlyText = false) {
        if (slug) {
            const content = this.getElementBySlug(slug)?.content;
            return onlyText && content ? this.getSimpleText(content) : content;
        }
    }

    getElementHtmlContentBySlug(slug: string) {
        if (slug) {
            const content = this.sanitizer.bypassSecurityTrustHtml(this.getElementBySlug(slug)?.content);
            return content;
        }
    }

    getElementBySlug(slug: string) {
        if (slug && Object.keys(this.dynamicElements)?.length) {
            return this.dynamicElements.find((el) => el.slug === slug);
        }
    }

    getSimpleText(htmlContent: string): string {
        const doc = new DOMParser().parseFromString('<div>' + htmlContent + '</div>', 'text/html');
        return doc.body.textContent || '';
    }
}
